// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","357":"1aff7318","453":"03346f77","455":"3b37999a","977":"240addac"}[chunkId] + ".chunk.js";
};